import axios from "axios";

const instance = axios.create({
    baseURL: 'https://us-central1-clone-7bbcb.cloudfunctions.net/api'
    // http://localhost:5001/clone-7bbcb/us-central1/api
});

export default instance;